// extracted by mini-css-extract-plugin
module.exports = {"List":"List__List_2Ezk9 grid","Card":"List__Card_3Q9zm","Note":"List__Note_35b47","Lead":"List__Lead_31RLI"};